/**
 * Zod input schemas: drivers. Split out of the one big schemas.ts (Oct 2026) so a session opens only the tool it
 * works on; nothing changed in the schemas themselves. Import as before, from '@daaily/shared' (or './schemas.js'
 * inside shared); the barrel re-exports every file in this folder. Shared primitives (EmailSchema, MonthSchema, …)
 * live in primitives.ts; cross-tool references are explicit imports between these files.
 */
import { z } from 'zod';
/** 'YYYY-MM' month key for a Drivers cycle. */
export const DriverMonthKeySchema = z
    .string()
    .trim()
    .regex(/^\d{4}-(0[1-9]|1[0-2])$/, 'Expected a YYYY-MM month.');
export const DriversNominateSchema = z.object({
    nomineeEmail: z.string().trim().toLowerCase().email(),
    valueId: z.string().trim().min(1).max(60),
    text: z
        .string()
        .trim()
        .min(1, 'Please explain why you are nominating this person.')
        // Word cap enforced separately (NOMINATION_MAX_WORDS); generous char guard.
        .max(4000),
    /** "Show my name" — true = show, false/absent → anonymous. */
    showName: z.boolean(),
});
export const DriversSetWinnerSchema = z.object({
    month: DriverMonthKeySchema,
    nomineeEmail: z.string().trim().toLowerCase().email(),
    /** null clears the winner status for this nominee. */
    valueId: z.string().trim().min(1).max(60).nullable(),
});
export const DriversMonthSchema = z.object({ month: DriverMonthKeySchema });
export const DriversReleaseSchema = z.object({ month: DriverMonthKeySchema });
export const DriversAnnualExportSchema = z.object({
    /** Four-digit year, e.g. 2026. */
    year: z.number().int().min(2000).max(2100),
});
/** Org summary filter: blank = all released months; month needs a year. */
export const DriversOrgSummarySchema = z
    .object({
    year: z.number().int().min(2000).max(2100).nullable().optional(),
    month: z.number().int().min(1).max(12).nullable().optional(),
})
    .refine((v) => !v.month || !!v.year, { message: 'Pick a year to filter by month.' });
//# sourceMappingURL=drivers.js.map